var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    height: 512,
    viewBox: "0 0 8.4666665 8.4666669",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -288.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1002",
    d: "m.78562533 289.06067a.26460982.26460982 0 0 0 -.2599325.26768v6.87865a.26460982.26460982 0 0 0 .2635498.26562h6.88123387a.26465001.26465001 0 1 0 0-.52917h-6.6151003v-6.6151a.26460982.26460982 0 0 0 -.26975087-.26768zm6.87865017 1.72031a.26460982.26460982 0 0 0 -.181385.0801l-2.7150794 2.71508-1.1363648-1.25006a.26460982.26460982 0 0 0 -.3731038-.0176l-1.5880167 1.45521a.26481563.26481563 0 1 0 .3576009.39068l1.3926797-1.27538 1.1425661 1.25781a.26460982.26460982 0 0 0 .3824055.01l2.9104165-2.91196a.26460982.26460982 0 0 0 -.191719-.4532z",
    fill: "#5555FF",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "rgb(0,0,0)",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "rgb(0,0,0)",
    "solid-opacity": 1,
    vectorEffect: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.6aa6a5c549187e4cc5a78d7504284028.svg";
export { ForwardRef as ReactComponent };